'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Spinner } from '@achra/ui/spinner';
import { Check } from 'lucide-react';
import { ONBOARDING_STEPS, TOTAL_STEPS } from '@/modules/onboarding/lib/constants';
interface OnboardingStepperProps {
  currentStep: number;
  // When the active step's work is in progress, its node shows a spinner.
  loading?: boolean;
}
function OnboardingStepper(t0) {
  const $ = _c(5);
  const {
    currentStep,
    loading: t1
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentStep || $[1] !== loading) {
    t2 = ONBOARDING_STEPS.map((step, index) => {
      const isDone = step.id < currentStep;
      const isActive = step.id === currentStep;
      const isLoading = isActive && loading;
      const isLast = index === TOTAL_STEPS - 1;
      return <li key={step.id} aria-current={isActive ? "step" : undefined} className="flex gap-4"><div className="flex flex-col items-center"><span aria-hidden="true" className={cn("flex size-8 shrink-0 items-center justify-center rounded-full border text-sm font-semibold transition-colors", isDone && "border-status-success bg-status-success text-white", isActive && "border-primary bg-primary text-primary-foreground", !isDone && !isActive && "border-input text-muted-foreground")}>{isDone ? <Check className="size-4" /> : isLoading ? <Spinner className="size-4" /> : step.id}</span>{!isLast ? <span aria-hidden="true" className={cn("my-1 w-px flex-1", isDone ? "bg-status-success" : "bg-border")} /> : null}</div><div className={cn("pb-8", isLast && "pb-0")}><p className={cn("text-sm leading-none font-semibold", isActive || isDone ? "text-foreground" : "text-muted-foreground")}>{step.title}{isDone ? <span className="sr-only"> (completed)</span> : null}{isLoading ? <span className="sr-only"> (in progress)</span> : null}</p><p className="text-muted-foreground mt-1.5 text-sm">{step.description}</p></div></li>;
    });
    $[0] = currentStep;
    $[1] = loading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <nav aria-label="Onboarding progress"><ol className="flex flex-col">{t2}</ol></nav>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { OnboardingStepper };